import EpisodeConsumptionPage, {
  getServerSideProps
  // } from '../../../../../../tv-shows/details/[showName]/[showId]/[episodeName]/[episodeId]/index';
} from '../../../../../../tv-shows/details/[showName]/[showId]/[episodeName_seasonNo]/[episodeId]/index';
export { getServerSideProps };
export default EpisodeConsumptionPage;
